import React, { FormEvent, useCallback, useEffect, useMemo, useState } from 'react'
import { AdminLayout } from '../../../layout/AdminLayout'
import { HeaderPage } from '../../../components/HeaderPage'
import { Label } from '../../../Korbantech/components/Label'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import TextareaInput from '../../../Korbantech/components/Inputs/TextareaInput'
import { Cause } from '../../../types/Causes'
import { Select } from '../../../Korbantech/components/Inputs/Select'
import useApi from '../../../hooks/useApi'
import { SubmitButton } from '../../../Korbantech/components/Buttons/SubmitButton'
import { useNavigate } from 'react-router-dom'

interface CausesHelper extends Cause {
    checked?: boolean
}
export const NewEmail = () => {

    const [causes, setCauses] = useState<CausesHelper[]>([])
    const api = useApi();
    const navigate = useNavigate()

    const loadCauses = useCallback(async () => {
        await api.get('/causes').then(res => {
            setCauses(res.data)
        })
    }, [api])

    const selectedCause = useMemo(() => {
        let selecteds: CausesHelper[] | undefined = []
        if (!causes) return undefined
        causes.forEach(item => {
            if (item.checked){
                selecteds?.push(item)
            }
        })
        return selecteds
    }, [causes])
    
    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)
  
        await api.post("/admin/emails", data).then(res => {
            navigate('/admin/emails')
        }).catch(console.log)

    }, [api, navigate])

    useEffect(() => {
        loadCauses()
    }, [loadCauses])

    return (
        <AdminLayout>
            <HeaderPage name='Novo E-mail' />
            <div className='flex justify-center'>
                <form onSubmit={handleSubmit} className='border rounded-md bg-white w-7/12 p-4'>
                    <div>
                        <div className='font-semibold'>Causa</div>
                        <Select multiple
                            selectLabel='Causa'
                            selected={causes.filter(c => c.checked).map(c => c.id)}
                            options={causes.map(c => ({
                                label: c.name,
                                value: c.id
                            }))}
                            onChange={opt =>
                                setCauses(prev =>
                                    prev.map(p =>
                                        opt.includes(p.id) ? { ...p, checked: true } : { ...p, checked: false }
                                    )
                                )
                            }

                        />
                    </div>
                    <div> 

                        {selectedCause && selectedCause?.length < 1 && 
                            <div className='text-md font-semibold text-gray-400 text-center p-3'>Sem destinatário</div> 
                        }
                        <div className='flex flex-wrap gap-3 my-2'>
                        {selectedCause?.map(item => (
                            <div className='border border-blue-300 rounded-md p-1'>{item.name}
                                <input hidden name={"causes[]"} value={item.id} />
                            </div>   
                        ))}
                        </div>
                    </div>
                    <Label>
                        <div className='text-lg font-semibold'>Assunto</div>
                        <TextInput name={`subject`}
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </Label>
                    <Label>
                        <div className='text-lg font-semibold'>Menssagem</div>
                        <TextareaInput name={`message`}
                            className={'bg-gray-200 rounded border border-gray-600 text-gray-700 my-2'} />
                    </Label>
                    <div className='w-4/12'>
                          <SubmitButton value={"Enviar emails"} />
                    </div>
                  
                </form>
            </div>
        </AdminLayout>
    )
}